import { Action } from '@ngrx/store';

export const GET_SSRS_CONFIG = '[Report] Get SSRS Config';

export class GetSsrsConfigAction implements Action {
  readonly type = GET_SSRS_CONFIG;
}



// WEBPACK FOOTER //
// ./src/app/report/store/actions/GetSsrsConfigAction.ts